import { useDynamicTranslations } from './useDynamicTranslations';

// Re-export the dynamic translations hook as the main translation hook
export const useTranslation = useDynamicTranslations;
export default useTranslation;